import { useEffect } from 'react'

/**
 * Takes a string and commits it to local storage
 * whenever the string changes
 * @param {string} state
 * @param {string} key
 */
export function useLocalStorage(state, key) {
    useEffect(() => {
        if (state) {
            localStorage.setItem(key, state)
        } else {
            localStorage.removeItem(key)
        }
    }, [state, key])
}
